<template>
    <InlineSvg :src="getIcon(iconName)" :width="width" :height="height" />
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
    name: 'icon',
    components: {
        InlineSvg,
    },
    props: {
        iconName: {
            type: String,
            default: 'text',
        },
        width: {
            type: Number,
            default: null
        },
        height: {
            type: Number,
            default: null
        }
    },
    methods: {
        getIcon(iconName) {


            switch (iconName) {
                // FAB
                case 'add-button':
                    return require('../../images/fab-icons/icon-fab-add-button.svg');
                case 'add-link':
                    return require('../../images/fab-icons/icon-fab-add-link.svg');
                case 'add-media':
                    return require('../../images/fab-icons/icon-fab-add-media.svg');
                case 'add-page':
                    return require('../../images/fab-icons/icon-fab-add-page.svg');
                case 'add-text':
                    return require('../../images/fab-icons/icon-fab-add-text.svg');
                case 'brush':
                case 'designer':
                    return require('../../images/fab-icons/icon-fab-brush.svg');
                case 'col-add':
                    return require('../../images/fab-icons/icon-fab-col-add.svg');
                case 'col-remove':
                    return require('../../images/fab-icons/icon-fab-col-remove.svg');
                case 'context-menu':
                    return require('../../images/fab-icons/icon-fab-context-menu.svg');
                case 'corner-radius':
                    return require('../../images/general-icons/corner-radius.svg');
                case 'crop':
                case 'crop-active':
                case 'crop-white':
                    return require('../../images/fab-icons/icon-fab-crop.svg');
                case 'delete':
                    return require('../../images/fab-icons/icon-fab-delete.svg');
                case 'desktop':
                    return require('../../images/fab-icons/icon-fab-desktop.svg');
                case 'down':
                case 'down-arrow':
                case 'arrow-down':
                case 'down-gray':
                    return require('../../images/fab-icons/icon-fab-down.svg');
                case 'drag':
                case 'rearrange':
                    return require('../../images/fab-icons/icon-fab-drag.svg');
                case 'animated-text-layout-wave':
                case 'animated-text-divider-wave':
                    return require('../../images/animated-text/divider/Wave.svg');
                case 'animated-text-divider-off':
                    return require('../../images/animated-text/divider/Off.svg');
                case 'animated-text-layout-linear':
                    return require('../../images/animated-text/layout/linear.svg');
                case 'animated-text-layout-wavy':
                    return require('../../images/animated-text/layout/wavy.svg');
                case 'animated-text-divider-arrow':
                    return require('../../images/animated-text/divider/Arrow.svg');
                case 'animated-text-divider-sparkle':
                    return require('../../images/animated-text/divider/Sparkle.svg');
                case 'animated-text-divider-star':
                    return require('../../images/animated-text/divider/Star.svg');
                case 'animated-text-interaction-slow-down':
                    return require('../../images/animated-text/interaction/slow.svg');
                case 'type-selector-animated-text-overflow-FULL_WIDTH':
                    return require('../../images/animated-text/overflow/full-width.svg');
                case 'type-selector-animated-text-overflow-CLIPPED':
                    return require('../../images/animated-text/overflow/clipped.svg');
                case 'type-selector-animated-text-overflow-FADED':
                    return require('../../images/animated-text/overflow/faded.svg');
                case 'type-selector-animated-text-hover-NONE':
                    return require('../../images/animated-text/interaction/none-box.svg');
                case 'type-selector-animated-text-hover-SLOW_DOWN':
                    return require('../../images/animated-text/interaction/slow.svg');
                case 'type-selector-animated-text-hover-PAUSE':
                    return require('../../images/animated-text/interaction/pause.svg');
                case 'type-selector-animated-text-click-NONE':
                    return require('../../images/animated-text/interaction/non-box-interaction.svg');
                case 'type-selector-animated-text-click-OPEN_LINK':
                    return require('../../images/animated-text/interaction/open-link.svg');
                case 'type-selector-animated-text-click-NAVIGATE_TO_PAGE':
                    return require('../../images/animated-text/interaction/navigate-page.svg');
                case 'edit-logo':
                    return require('../../images/fab-icons/icon-fab-edit-logo.svg');
                case 'edit-pages':
                    return require('../../images/fab-icons/icon-fab-edit-pages.svg');
                case 'effects':
                case 'effects-active':
                    return require('../../images/fab-icons/icon-fab-effects.svg');
                case 'email-settings':
                    return require('../../images/fab-icons/icon-fab-email-settings.svg');
                case 'flip':
                    return require('../../images/fab-icons/icon-fab-flip.svg');
                case 'global-spacing':
                    return require('../../images/fab-icons/icon-fab-global-spacing.svg');
                case 'spacer-top':
                    return require('../../images/fab-icons/icon-fab-spacer-top.svg');
                case 'spacer-bottom':
                    return require('../../images/fab-icons/icon-fab-spacer-bottom.svg');
                case 'idea':
                    return require('../../images/fab-icons/icon-fab-idea.svg');
                case 'image-bi-cover':
                    return require('../../images/fab-icons/icon-fab-image-bi-cover.svg');
                case 'image-bottom-align':
                    return require('../../images/fab-icons/icon-fab-image-bottom-align.svg');
                case 'image-display':
                    return require('../../images/fab-icons/icon-fab-image-display.svg');
                case 'image-display-mode':
                    return require('../../images/fab-icons/icon-fab-image-display-mode.svg');
                case 'image-fit':
                    return require('../../images/fab-icons/icon-fab-image-fit.svg');
                case 'image-fit-margin':
                    return require('../../images/fab-icons/icon-fab-image-fit-margin.svg');
                case 'image-it-large':
                    return require('../../images/fab-icons/icon-fab-image-it-large.svg');
                case 'image-it-medium':
                    return require('../../images/fab-icons/icon-fab-image-it-medium.svg');
                case 'image-it-small':
                    return require('../../images/fab-icons/icon-fab-image-it-small.svg');
                case 'image-large':
                    return require('../../images/fab-icons/icon-fab-image-large.svg');
                case 'image-medium':
                    return require('../../images/fab-icons/icon-fab-image-medium.svg');
                case 'image-null':
                case 'disabled':
                case 'not-allowed':
                case 'no-mockup':
                    return require('../../images/fab-icons/icon-fab-image-null.svg');
                case 'image-small':
                    return require('../../images/fab-icons/icon-fab-image-small.svg');
                case 'layout':
                case 'layout-active':
                    return require('../../images/fab-icons/icon-fab-layout.svg');
                case 'card-layout-row-2':
                    return require('../../images/cards-layouts/card-layout-row-2.svg');
                case 'card-layout-row-3':
                    return require('../../images/cards-layouts/card-layout-row-3.svg');
                case 'card-layout-grid-2x2':
                    return require('../../images/cards-layouts/card-layout-row-2x2.svg');
                case 'card-layout-grid-3x2':
                    return require('../../images/cards-layouts/card-layout-row-3x2.svg');
                case 'left':
                case 'arrow-left':
                    return require('../../images/fab-icons/icon-fab-left.svg');
                case 'lock':
                    return require('../../images/fab-icons/icon-fab-lock.svg');
                case 'password-lock':
                    return require('../../images/icon-password-lock.svg');
                case 'safari-lock':
                    return require('../../images/icon-safari-lock.svg');
                case 'unlock':
                    return  require('../../images/fab-icons/icon-fab-unlock.svg');
                case 'mobile':
                    return require('../../images/fab-icons/icon-fab-mobile.svg');
                case 'mockups':
                case 'mockups-active':
                    return require('../../images/fab-icons/icon-fab-mockups.svg');
                case 'remove-mockup':
                    return require('../../images/fab-icons/icon-fab-remove-mockup.svg');
                case 'nav-background-fill':
                    return require('../../images/fab-icons/icon-fab-nav-background-fill.svg');
                case 'nav-font-color':
                    return require('../../images/fab-icons/icon-fab-nav-font-color.svg');
                case 'pages':
                    return require('../../images/fab-icons/icon-fab-pages.svg');
                case 'page':
                    return require('../../images/general-icons/page.svg')
                case 'password':
                    return require('../../images/fab-icons/icon-fab-password.svg');
                case 'remove-media':
                    return require('../../images/fab-icons/icon-fab-remove-media.svg');
                case 'remove-page':
                    return require('../../images/fab-icons/icon-fab-remove-page.svg');
                case 'remove-thumbnail':
                    return require('../../images/fab-icons/icon-fab-remove-thumbnail.svg');
                case 'reorder-arrows':
                    return require('../../images/fab-icons/icon-fab-reorder.svg');
                case 'replace':
                    return require('../../images/fab-icons/icon-fab-replace.svg');
                case 'resize':
                    return require('../../images/fab-icons/icon-fab-resize.svg');
                case 'right':
                case 'arrow-right':
                    return require('../../images/fab-icons/icon-fab-right.svg');
                case 'arrow-horizontal':
                    return require('../../images/arrows/arrow-horizontal.svg')
                case 'rotate':
                case 'rotate-mockup':
                    return require('../../images/fab-icons/icon-fab-rotate-mockup.svg');
                case 'change-background':
                case 'set-background':
                case 'image-cover':
                    return require('../../images/fab-icons/icon-fab-set-background.svg');
                case 'set-default-portfolio':
                    return require('../../images/fab-icons/icon-fab-set-default-portfolio.svg');
                case 'settings':
                case 'settings-light':
                    return require('../../images/fab-icons/icon-fab-settings.svg');
                case 'social-link':
                case 'social-links':
                    return require('../../images/icon-social-link.svg');
                case 'space-decrease':
                    return require('../../images/fab-icons/icon-fab-space-decrease.svg');
                case 'space-increase':
                    return require('../../images/fab-icons/icon-fab-space-increase.svg');
                case 'design':
                case 'style':
                    return require('../../images/fab-icons/icon-fab-style.svg');
                case 'success':
                    return require('../../images/fab-icons/icon-fab-success.svg');
                case 'tablet':
                    return require('../../images/fab-icons/icon-fab-tablet.svg');
                case 'thumbnail-layout':
                    return require('../../images/fab-icons/icon-fab-thumbnail-layout.svg');
                case 'thumbnails':
                    return require('../../images/fab-icons/icon-fab-thumbnails.svg');
                case 'up':
                case 'arrow-up':
                    return require('../../images/fab-icons/icon-fab-up.svg');
                case 'arrow-out':
                    return require("../../images/arrows/arrow-out.svg")
                case 'change-image':
                case 'change-image-active':
                case 'upload':
                    return require('../../images/fab-icons/icon-fab-upload.svg');
                case 'history':
                    return require("../../images/fab-icons/icon-fab-history.svg");
                case 'history-clock':
                    return require('../../images/fab-icons/icon-fab-history-clock.svg');
                case 'filters':
                    return require("../../images/fab-icons/icon-fab-filters.svg")

                // general icons
                case 'add':
                    return require('../../images/general-icons/add.svg');
                case 'subtract':
                    return  require('../../images/general-icons/subtract.svg');
                case 'add-case-study-gradient':
                    return require('../../images/general-icons/add-case-study-gradient.svg');
                case 'arrows':
                    return require('../../images/general-icons/arrows.svg');
                case 'back':
                    return require('../../images/general-icons/back.svg');
                case 'check':
                case 'checkmark':
                case 'ok':
                    return require('../../images/general-icons/checkmark.svg');
                case 'chevron-down':
                    return require('../../images/general-icons/chev-down.svg');
                case 'chevron-left':
                    return require('../../images/general-icons/chev-left.svg');
                case 'chevron-right':
                    return require('../../images/general-icons/chev-right.svg');
                case 'chevron-up':
                    return require('../../images/general-icons/chev-up.svg');
                case 'copy':
                case 'duplicate':
                    return require('../../images/general-icons/copy.svg');
                case 'draft':
                    return require('../../images/general-icons/draft.svg');
                case 'caret-down':
                case 'dropdown-select':
                    return require('../../images/general-icons/dropdown-select.svg');
                case 'dark':
                    return require('../../images/general-icons/dark.svg');
                case 'figma-mono':
                    return require('../../images/general-icons/figma-mono.svg');
                case 'favicon':
                    return require('../../images/general-icons/favicon.svg');
                case 'folder':
                    return require('../../images/general-icons/folder.svg');
                case 'font-size-icon':
                    return require('../../images/general-icons/font-size-icon.svg');
                case 'globe':
                    return require('../../images/general-icons/globe.svg');
                case 'hidden':
                case 'notvisible':
                    return require('../../images/general-icons/hidden.svg');
                case 'hidden-gradient':
                    return require('../../images/general-icons/hidden-gradient.svg');
                case 'info':
                    return require('../../images/general-icons/info.svg');
                case 'italic':
                    return require('../../images/general-icons/italic.svg');
                case 'key':
                    return require('../../images/general-icons/key.svg');
                case 'light':
                    return require('../../images/general-icons/light.svg');
                case 'line-height-icon':
                    return require('../../images/general-icons/line-height-icon.svg');
                case 'minus':
                    return require('../../images/general-icons/minus.svg');
                case 'navigation':
                    return require('../../images/general-icons/navigation.svg');
                case 'presentation':
                    return require('../../images/general-icons/presentation.svg');
                case 'public':
                    return require('../../images/general-icons/public.svg');
                case 'publish':
                    return require('../../images/general-icons/publish.svg');
                case 'replay':
                  return require('../../images/general-icons/replay.svg');
                case 'unpublish':
                    return require('../../images/general-icons/unpublish.svg');
                case 'restart':
                case 'redo':
                    return require('../../images/general-icons/restart.svg');
                case 'review':
                    return  require('../../images/general-icons/review.svg');
                case 'share':
                    return require('../../images/general-icons/share.svg');
                case 'visible':
                case 'preview':
                    return require('../../images/general-icons/visible.svg');
                case 'no-index':
                    return require('../../images/general-icons/no-index.svg');
                case 'notification':
                    return require('../../images/general-icons/notification.svg');
                case 'gift':
                    return require('../../images/general-icons/gift.svg');
                case 'paste':
                    return require('../../images/general-icons/icon-paste.svg')
                case 'payment':
                    return require('../../images/general-icons/payment.svg');
                case 'profile':
                    return require('../../images/general-icons/profile.svg');
                case 'reorder':
                    return require('../../images/general-icons/reorder.svg')
                case 'tools':
                    return require('../../images/general-icons/tools.svg');
                case 'warning':
                    return require('../../images/general-icons/warning.svg');
                case 'web':
                    return require('../../images/general-icons/web.svg');
                case 'discount':
                    return require('../../images/general-icons/discount.svg');
                case 'percent-discount':
                    return require('../../images/general-icons/percent-discount.svg');
                case 'thumbs-up':
                    return require('../../images/general-icons/thumb_up.svg');
                case 'thumbs-down':
                    return require('../../images/general-icons/thumb_down.svg');


                // text editor
                case 'alt':
                    return require('../../images/text-editor-icons/alt-text.svg');
                case 'x':
                case 'close':
                case 'close-light':
                    return require('../../images/text-editor-icons/close-light.svg');
                case 'done':
                    return require('../../images/text-editor-icons/done.svg');
                case 'edit':
                    return require('../../images/text-editor-icons/edit.svg');
                case 'edit-link':
                    return require('../../images/text-editor-icons/edit-link.svg');
                case 'remove-colors':
                    return require('../../images/text-editor-icons/remove-colors.svg');
                case 'style-thick':
                    return require('../../images/text-editor-icons/style-thick.svg');
                case 'text-bold':
                    return require('../../images/text-editor-icons/text-bold.svg');
                case 'text-center':
                    return require('../../images/text-editor-icons/text-center.svg');
                case 'text-format-remove':
                    return require('../../images/text-editor-icons/text-format-remove.svg');
                case 'text-h':
                    return require('../../images/text-editor-icons/text-h.svg');
                case 'text-h1':
                    return require('../../images/text-editor-icons/text-h1.svg');
                case 'text-h2':
                    return require('../../images/text-editor-icons/text-h2.svg');
                case 'text-h3':
                    return require('../../images/text-editor-icons/text-h3.svg');
                case 'text-h4':
                    return require('../../images/text-editor-icons/text-h4.svg');
                case 'text-italic':
                    return require('../../images/text-editor-icons/text-italic.svg');
                case 'text-left':
                    return require('../../images/text-editor-icons/text-left.svg');
                case 'link':
                case 'text-link':
                    return require('../../images/text-editor-icons/text-link.svg');
                case 'text-ol':
                    return require('../../images/text-editor-icons/text-ol.svg');
                case 'text-p':
                    return require('../../images/text-editor-icons/text-p.svg');
                case 'text-p1':
                    return require('../../images/text-editor-icons/text-p1.svg');
                case 'text-p2':
                    return require('../../images/text-editor-icons/text-p2.svg');
                case 'text-quote':
                    return require('../../images/text-editor-icons/text-quote.svg');
                case 'text-right':
                    return require('../../images/text-editor-icons/text-right.svg');
                case 'text-ul':
                    return require('../../images/text-editor-icons/text-ul.svg');
                case 'text-underline':
                    return require('../../images/text-editor-icons/text-underline.svg');
                case 'unlink':
                case 'text-unlink':
                    return require('../../images/text-editor-icons/text-unlink.svg');

                // crop icons
                case 'crop_1_1':
                    return require('../../images/crop-options/crop_1_1.svg');
                case 'crop_2_3':
                    return require('../../images/crop-options/crop_2_3.svg');
                case 'crop_3_2':
                    return require('../../images/crop-options/crop_3_2.svg');
                case 'crop_4_5':
                    return require('../../images/crop-options/crop_4_5.svg');
                case 'crop_5_4':
                    return require('../../images/crop-options/crop_5_4.svg');
                case 'crop_9_16':
                    return require('../../images/crop-options/crop_9_16.svg');
                case 'crop_16_9':
                    return require('../../images/crop-options/crop_16_9.svg');
                case 'crop_circle':
                    return require('../../images/crop-options/crop_circle.svg');
                case 'crop_custom':
                    return require('../../images/crop-options/crop_custom.svg');
                case 'crop_original':
                    return require('../../images/crop-options/crop_original.svg');

                // aspect ratio options
                case 'aspect-ratio-1_1':
                    return require('../../images/aspect-ratios/1_1.svg');
                case 'aspect-ratio-3_4':
                    return require('../../images/aspect-ratios/3_4.svg');
                case 'aspect-ratio-4_3':
                    return require('../../images/aspect-ratios/4_3.svg');
                case 'aspect-ratio-9_16':
                    return require('../../images/aspect-ratios/9_16.svg');
                case 'aspect-ratio-16_9':
                    return require('../../images/aspect-ratios/16_9.svg');
                case 'aspect-ratio-Original':
                    return require('../../images/aspect-ratios/Original.svg');

                // gallery controls
                case 'gallery-arrow-left':
                    return require('../../images/gallery-controls/gallery-arrow-left.svg');
                case 'gallery-arrow-right':
                    return require('../../images/gallery-controls/gallery-arrow-right.svg');

                // mockup icons
                case 'colorScheme-dark':
                    return require('../../images/mockup-icons/color-dark.svg');
                case 'colorScheme-light':
                    return require('../../images/mockup-icons/color-light.svg');
                case 'settings-notch':
                    return require('../../images/mockup-icons/settings-notch.svg');
                case 'settings-island':
                    return require('../../images/mockup-icons/settings-island.svg');
                case 'settings-simple':
                    return require('../../images/mockup-icons/settings-simple.svg');
                case 'settings-rounded':
                    return require('../../images/mockup-icons/corner-rounded.svg');
                case 'settings-squared':
                    return require('../../images/mockup-icons/corner-squared.svg');
                case 'shadow-no-shadow':
                    return require('../../images/mockup-icons/effects-no-shadow.svg');
                case 'shadow-shadow':
                    return require('../../images/mockup-icons/effects-shadow.svg');
                case 'mockupType-browser':
                    return require('../../images/mockup-icons/style-browser.svg');
                case 'mockupType-outline':
                    return require('../../images/mockup-icons/style-outline.svg');
                case 'mockupType-semirealistic':
                    return require('../../images/mockup-icons/style-semi-realistic.svg');
                case 'mockupType-realistic':
                    return require('../../images/mockup-icons/style-realistic.svg');
                case 'mockupType-simple':
                    return require('../../images/mockup-icons/style-simple.svg');
                case 'mockupType-minimal':
                    return require('../../images/mockup-icons/corner-rounded.svg');
                case 'deviceType-laptop':
                    return require('../../images/mockup-icons/type-laptop.svg');
                case 'deviceType-mobile':
                    return require('../../images/mockup-icons/type-mobile.svg');
                case 'deviceType-desktop':
                    return require('../../images/mockup-icons/type-desktop.svg');
                case 'deviceType-none':
                    return require('../../images/mockup-icons/type-none.svg');
                case 'deviceType-tablet':
                    return require('../../images/mockup-icons/type-tablet.svg');

                //  Thumbnail Generator
                //mobile layouts
                case 'mobile_single_middle':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_single_middle.svg");
                case 'mobile_single_slided':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_single_slided.svg");
                case 'mobile_dual_middle':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_dual_middle.svg");
                case 'mobile_dual_slided':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_dual_slided.svg");
                case 'mobile_triple_middle':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_triple_middle.svg");
                case 'mobile_triple_slided':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_triple_slided.svg");
                case 'mobile_triple_slided_rotated':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_triple_slided_rotated.svg");
                case 'mobile_triple_middle_horizontal':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_triple_middle_horizontal.svg");
                case 'mobile_quadruple_slided':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_quadruple_slided.svg");
                case 'mobile_quadruple_slided_rotated':
                    return require("../../images/thumbnail-generation/layouts/mobile/mobile_quadruple_slided_rotated.svg");

                    //Desktop layouts
                case 'desktop_single_middle':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_single_middle.svg");
                case 'desktop_single_slided':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_single_slided.svg");
                case 'desktop_mobile_overlay':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_mobile_overlay.svg");
                case 'desktop_mobile_middle':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_mobile_middle.svg");
                case 'desktop_single_slided_big':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_single_slided_big.svg");
                case 'desktop_triple_variety':
                    return require("../../images/thumbnail-generation/layouts/desktop/desktop_triple_variety.svg");

                    //Tablet layouts
                case 'tablet_single_middle':
                    return require("../../images/thumbnail-generation/layouts/tablet/tablet_single_middle.svg");
                case 'tablet_single_slided':
                    return require("../../images/thumbnail-generation/layouts/tablet/tablet_single_slided.svg");
                case 'tablet_mobile_overlay':
                    return require("../../images/thumbnail-generation/layouts/tablet/tablet_mobile_overlay.svg");
                case 'tablet_mobile_middle':
                    return require("../../images/thumbnail-generation/layouts/tablet/tablet_mobile_middle.svg");
                case 'tablet_single_slided_big':
                    return require("../../images/thumbnail-generation/layouts/tablet/tablet_single_slided_big.svg");

                    //Monitor layouts
                case 'monitor_single_middle':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_single_middle.svg");
                case 'monitor_mobile_middle':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_mobile_middle.svg");
                case 'monitor_desktop_middle':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_desktop_middle.svg");
                case 'monitor_tablet_middle':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_tablet_middle.svg");
                case 'monitor_triple_variety':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_triple_variety.svg");
                case 'monitor_quadruple_variety':
                    return require("../../images/thumbnail-generation/layouts/monitor/monitor_quadruple_variety.svg");

                    //device styles
                case 'device_style_browser':
                    return require("../../images/thumbnail-generation/icons/device-styles/device_style_browser.svg");
                case 'device_style_no_device':
                    return require("../../images/thumbnail-generation/icons/device-styles/device_style_no-device.svg");
                case 'device_style_outline':
                    return require("../../images/thumbnail-generation/icons/device-styles/device_style_outline.svg");
                case 'device_style_semi_realistic':
                    return require("../../images/thumbnail-generation/icons/device-styles/device_style_semi-realistic.svg");
                case 'device_style_simple':
                    return require("../../images/thumbnail-generation/icons/device-styles/device_style_simple.svg");

                    //background styles
                case 'background_gradient':
                    return require("../../images/thumbnail-generation/icons/background-styles/background_gradient.svg");
                case 'background_transparent':
                    return require("../../images/thumbnail-generation/icons/background-styles/background_transparent.svg");
                case 'background_solid':
                    return require("../../images/thumbnail-generation/icons/background-styles/background_solid.svg");

                    //color styles
                case 'color_light':
                    return require("../../images/thumbnail-generation/icons/color-styles/device_color_light.svg");
                case 'color_dark':
                    return require("../../images/thumbnail-generation/icons/color-styles/device_color_dark.svg");

                    //corner styles
                case 'device_corner_rounded':
                    return require("../../images/thumbnail-generation/icons/corner-styles/device_corner_rounded.svg");
                case 'device_corner_squareed':
                    return require("../../images/thumbnail-generation/icons/corner-styles/device_corner_squared.svg");

                    //gradient styles styles
                case 'gradient_linear_1':
                    return require("../../images/thumbnail-generation/icons/gradient-styles/gradient_linear_1.svg");
                case 'gradient_linear_2':
                    return require("../../images/thumbnail-generation/icons/gradient-styles/gradient_linear_2.svg");
                case 'gradient_linear_3':
                    return require("../../images/thumbnail-generation/icons/gradient-styles/gradient_linear_3.svg");
                case 'gradient_radial_1':
                    return require("../../images/thumbnail-generation/icons/gradient-styles/gradient_radial_1.svg");

                //  Design panel - Animation  //

                case 'anim-none':
                    return require("../../images/animations/preset_icons/none.svg");
                case 'anim-rise':
                    return require("../../images/animations/preset_icons/rise.svg");
                case 'anim-fall':
                    return require("../../images/animations/preset_icons/fall.svg");
                case 'anim-pan-left':
                    return require("../../images/animations/preset_icons/pan-left.svg");
                case 'anim-pan-right':
                    return require("../../images/animations/preset_icons/pan-right.svg");
                case 'anim-fade-in':
                    return require("../../images/animations/preset_icons/fade-in.svg");
                case 'anim-move-in':
                    return require("../../images/animations/preset_icons/move-in.svg");
                case 'anim-bring-in':
                    return require("../../images/animations/preset_icons/bring-in.svg");
                case 'anim-scale':
                    return require("../../images/animations/preset_icons/scale.svg");

                //  Design panel - Buttons  //

                case 'outlined-pill':
                    return require("../../images/buttons/outlined-pill.svg");
                case 'outlined-rounded':
                    return require("../../images/buttons/outlined-rounded.svg");
                case 'outlined-square':
                    return require("../../images/buttons/outlined-square.svg");
                case 'solid-pill':
                    return require("../../images/buttons/solid-pill.svg");
                case 'solid-rounded':
                    return require("../../images/buttons/solid-rounded.svg");
                case 'solid-square':
                    return require("../../images/buttons/solid-square.svg");

                case 'outline-weight-1':
                    return require("../../images/buttons/outline-weight-1.svg");
                case 'outline-weight-2':
                    return require("../../images/buttons/outline-weight-2.svg");
                case 'outline-weight-3':
                    return require("../../images/buttons/outline-weight-3.svg");
                case 'outline-weight-4':
                    return require("../../images/buttons/outline-weight-4.svg");

                // Design panel - Social links
                case 'social-link-shape-square':
                        return require("../../images/social-links/social-link-shape-square.svg");
                case 'social-link-shape-rounded':
                    return require("../../images/social-links/social-link-shape-rounded.svg");
                case 'social-link-shape-circle':
                    return require("../../images/social-links/social-link-shape-circle.svg");

                //  Design panel - Thumbnail  //

                    //Presets
                case 'preset1':
                    return require('../../images/thumbnail-alignments/presets/small-block_below_center_center.svg');
                case 'preset3':
                    return require('../../images/thumbnail-alignments/presets/small-block-slided--hover--center--center.svg');
                case 'preset4':
                    return require('../../images/thumbnail-alignments/presets/small-block-slided--below--left--center.svg');
                case 'preset7':
                    return require('../../images/thumbnail-alignments/presets/large-block-mixed--hover--center--center.svg');
                case 'preset8':
                    return require('../../images/thumbnail-alignments/presets/large-block_below_left_center.svg');
                case 'preset9':
                    return require('../../images/thumbnail-alignments/presets/small-block-text_right_left_center.svg');
                case 'preset12':
                    return require('../../images/thumbnail-alignments/presets/medium-block-text_alternating_center_center.svg');

                //  Layouts
                case 'largeBlock':
                case 'large-block':
                    return require("../../images/thumbnail-alignments/layout/large-block.svg");
                case 'mediumBlockText':
                case 'medium-block-text':
                    return require("../../images/thumbnail-alignments/layout/medium-block-text.svg");
                case 'mixedBlockLarge':
                case 'large-block-mixed':
                    return require("../../images/thumbnail-alignments/layout/large-block-mixed.svg");
                case 'smallBlock':
                case 'small-block':
                    return require("../../images/thumbnail-alignments/layout/small-block.svg");
                case 'smallBlockSlide':
                case 'small-block-slided':
                    return require("../../images/thumbnail-alignments/layout/small-block-slided.svg");
                case 'smallBlockText':
                case 'small-block-text':
                    return require("../../images/thumbnail-alignments/layout/small-block-text.svg");
                case 'smallBlockTextOnly':
                case 'small-block-text-only':
                    return require("../../images/thumbnail-alignments/layout/small-block-text-only.svg");
                case 'largeBlockTextOnly':
                case 'large-block-text-only':
                    return require("../../images/thumbnail-alignments/layout/large-block-text-only.svg");

                //Text Alignments
                case 'aboveAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/above_alignment.svg");
                case 'alternatingAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/alternating_alignment.svg");
                case 'belowAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/below_alignment.svg");
                case 'hiddenAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/hidden_alignment.svg");
                case 'hoverAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/hover_alignment.svg");
                case 'insideAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/inside_alignment.svg");
                case 'leftAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/left_alignment.svg");
                case 'rightAlignment':
                    return require("../../images/thumbnail-alignments/text-alignments/right_alignment.svg");

                // Case study grid text positions
                case 'type-selector-textPosition-below':
                    return require("../../images/thumbnail-alignments/text-position-selector/below.svg");
                case 'type-selector-textPosition-above':
                    return require("../../images/thumbnail-alignments/text-position-selector/above.svg");
                case 'type-selector-textPosition-on-thumbnail':
                    return require("../../images/thumbnail-alignments/text-position-selector/on-thumbnail.svg");
                case 'type-selector-textPosition-hover':
                    return require("../../images/thumbnail-alignments/text-position-selector/hover.svg");
                case 'type-selector-textPosition-hidden':
                    return require("../../images/thumbnail-alignments/text-position-selector/hidden.svg");
                case 'type-selector-textPosition-right':
                    return require("../../images/thumbnail-alignments/text-position-selector/right.svg");
                case 'type-selector-textPosition-left':
                    return require("../../images/thumbnail-alignments/text-position-selector/left.svg");
                case 'type-selector-textPosition-alternating':
                    return require("../../images/thumbnail-alignments/text-position-selector/alternating.svg");


                //  Title alignments
                case 'horizontal-center':
                case 'horizontalCenter':
                    return require("../../images/thumbnail-alignments/title-alignments/horizontal/horizontal_center.svg");
                case 'horizontal-left':
                case 'horizontalLeft':
                    return require("../../images/thumbnail-alignments/title-alignments/horizontal/horizontal_left.svg");
                case 'horizontal-right':
                case 'horizontalRight':
                    return require("../../images/thumbnail-alignments/title-alignments/horizontal/horizontal_right.svg");
                case 'vertical-bottom':
                case 'verticalBottom':
                    return require("../../images/thumbnail-alignments/title-alignments/vertical/vertical_bottom.svg");
                case 'vertical-middle':
                case 'verticalCenter':
                    return require("../../images/thumbnail-alignments/title-alignments/vertical/vertical_center.svg");
                case 'vertical-top':
                case 'verticalTop':
                    return require("../../images/thumbnail-alignments/title-alignments/vertical/vertical_top.svg");

                // colors
                case 'whiteText':
                    return require("../../images/thumbnail-alignments/color-switch/white_text.svg");
                case 'blackText':
                    return require("../../images/thumbnail-alignments/color-switch/black_text.svg");

                // Divider lines //

                //  text position icons
                case 'text_position_full_width_above':
                    return require('../../images/divider-line/icons/text-position/text-position--full-width--above.svg');
                case 'text_position_full_width_below':
                    return require('../../images/divider-line/icons/text-position/text-position--full-width--below.svg');
                case 'text_position_full_width_inline':
                    return require('../../images/divider-line/icons/text-position/text-position--full-width--inline.svg');
                case 'text_position_full_width_no_text':
                    return require('../../images/divider-line/icons/text-position/text-position--full-width--no-text.svg');

                //  text position - squared
                case 'above':
                    return require('../../images/divider-line/layout/above.svg');
                case 'below':
                    return require('../../images/divider-line/layout/below.svg');
                case 'in_line':
                    return require('../../images/divider-line/layout/in_line.svg');
                case 'no_text':
                    return require('../../images/divider-line/layout/no_text.svg');


                // line weight
                case 'weight_light':
                    return require('../../images/divider-line/icons/weight/weight--light.svg');
                case 'weight_medium':
                    return require('../../images/divider-line/icons/weight/weight--medium.svg');
                case 'weight_bold':
                    return require('../../images/divider-line/icons/weight/weight--bold.svg');

                // background generator thumbnails
                case 'bg_style_1':
                    return require('../../images/background_generator/thumbnails/bg_style_1.svg');
                case 'bg_style_2':
                    return require('../../images/background_generator/thumbnails/bg_style_2.svg');
                case 'bg_style_3':
                    return require('../../images/background_generator/thumbnails/bg_style_3.svg');
                case 'bg_style_4':
                    return require('../../images/background_generator/thumbnails/bg_style_4.svg');
                case 'bg_style_5':
                    return require('../../images/background_generator/thumbnails/bg_style_5.svg');
                case 'bg_style_6':
                    return require('../../images/background_generator/thumbnails/bg_style_6.svg');
                case 'bg_style_7':
                    return require('../../images/background_generator/thumbnails/bg_style_7.svg');
                case 'bg_style_8':
                    return require('../../images/background_generator/thumbnails/bg_style_8.svg');
                case 'bg_style_9':
                    return require('../../images/background_generator/thumbnails/bg_style_9.svg');

                // General settings
                // Content alignment
                case 'content-align-left':
                    return require('../../images/general-alignment/content-align-left.svg');
                case 'content-align-center':
                    return require('../../images/general-alignment/content-align-center.svg');
                case 'content-align-right':
                    return require('../../images/general-alignment/content-align-right.svg');
                case 'content-align-top':
                    return require('../../images/general-alignment/content-align-top.svg');
                case 'content-align-middle':
                    return require('../../images/general-alignment/content-align-middle.svg');
                case 'content-align-bottom':
                    return require('../../images/general-alignment/content-align-bottom.svg');

                // radius, rounding
                case 'radius-lg':
                    return require('../../images/case-study-cards/radius-lg.svg');
                case 'radius-md':
                    return require('../../images/case-study-cards/radius-md.svg');
                case 'radius-sm':
                    return require('../../images/case-study-cards/radius-sm.svg');
                case 'radius-no':
                    return require('../../images/case-study-cards/radius-no.svg');

                // TYPE SELECTOR
                // background styles
                case 'type-selector-image':
                    return require("../../images/background_generator/types/background-type-image.svg");
                case 'type-selector-upload_image':
                    return require("../../images/background_generator/types/background-type-image-thumbnail.svg");
                case 'type-selector-curated-backgrounds':
                case 'type-selector-curated_backgrounds':
                    return require("../../images/background_generator/types/background-type-curated-images.svg");
                case 'type-selector-gradient':
                    return require("../../images/background_generator/types/background-type-gradient.svg");
                case 'type-selector-solid':
                case 'type-selector-solid_color':
                    return require("../../images/background_generator/types/background-type-solid.svg");
                case 'type-selector-none':
                case 'type-selector-transparent':
                    return require("../../images/background_generator/types/background-type-none.svg");
                case 'type-selector-animated':
                    return require("../../images/animated-bg-icons/anim-type-selector-icon.svg");

                // gallery device types
                case 'gallery-device-type-desktop':
                    return require("../../images/gallery-device-types/galley-device-type-desktop.svg");
                case 'gallery-device-type-laptop':
                    return require("../../images/gallery-device-types/galley-device-type-laptop.svg");
                case 'gallery-device-type-tablet':
                    return require("../../images/gallery-device-types/galley-device-type-tablet.svg");
                case 'gallery-device-type-mobile':
                    return require("../../images/gallery-device-types/galley-device-type-mobile.svg");
                case 'gallery-device-type-none':
                    return require("../../images/gallery-device-types/galley-device-type-none.svg");



                // gallery layout types
                case 'type-selector-gallery-Grid':
                    return require("../../images/gallery-layouts/gallery-grid.svg");
                case 'type-selector-gallery-OffsetGrid':
                    return require("../../images/gallery-layouts/gallery-offset-grid.svg");
                case 'type-selector-gallery-Carousel':
                    return require("../../images/gallery-layouts/gallery-carousel.svg");
                case 'type-selector-gallery-Slider':
                    return require("../../images/gallery-layouts/gallery-slider.svg");
                case 'type-selector-gallery-Tilted':
                    return require("../../images/gallery-layouts/gallery-tilted.svg");

                // logo wall layout
                case 'type-selector-logo-wall-layout-GRID':
                    return require("../../images/logo-wall-icon/layouts/logo-wall-layout-grid.svg");
                case 'type-selector-logo-wall-layout-CAROUSEL':
                    return require("../../images/logo-wall-icon/layouts/logo-wall-layout-scrolling.svg");
                // hover interactions (standalone + type-selector)
                case 'hover-interaction-none':
                case 'type-selector-hover-interaction-NONE':
                    return require("../../images/animated-text/interaction/none-box.svg");
                case 'hover-interaction-color-reveal':
                case 'type-selector-hover-interaction-COLOR_REVEAL':
                    return require("../../images/hover-interaction-icons/hover-interaction-color-reveal.svg");
                case 'hover-interaction-scale-up':
                case 'type-selector-hover-interaction-SCALE_UP':
                    return require("../../images/hover-interaction-icons/hover-interaction-scale-up.svg");
                case 'hover-interaction-opacity-increase':
                case 'type-selector-hover-interaction-OPACITY_INCREASE':
                    return require("../../images/hover-interaction-icons/hover-interaction-opacity-increase.svg");

                // devices
                case 'type-selector-deviceType-none':
                    return require('../../images/mockup-icons/device-none.svg');
                case 'type-selector-deviceType-Mobile':
                    return require('../../images/thumbnail-generation/layouts/mobile/mobile_single_middle.svg');
                case 'type-selector-deviceType-Tablet':
                    return require('../../images/thumbnail-generation/layouts/tablet/tablet_single_middle.svg');
                case 'type-selector-deviceType-Laptop':
                    return require('../../images/thumbnail-generation/layouts/desktop/desktop_single_middle.svg');
                case 'type-selector-deviceType-Desktop':
                    return require('../../images/thumbnail-generation/layouts/monitor/monitor_single_middle.svg');
                case 'type-selector-gallery-device-type-none':
                    return require('../../images/gallery-device-types/galley-device-type-none.svg');
                case 'type-selector-gallery-device-type-mobile':
                case 'type-selector-gallery-device-type-Mobile':
                    return require('../../images/gallery-device-types/galley-device-type-mobile.svg');
                case 'type-selector-gallery-device-type-tablet':
                case 'type-selector-gallery-device-type-Tablet':
                    return require('../../images/gallery-device-types/galley-device-type-tablet.svg');
                case 'type-selector-gallery-device-type-laptop':
                case 'type-selector-gallery-device-type-Laptop':
                    return require('../../images/gallery-device-types/galley-device-type-laptop.svg');
                case 'type-selector-gallery-device-type-desktop':
                case 'type-selector-gallery-device-type-Desktop':
                    return require('../../images/gallery-device-types/galley-device-type-desktop.svg');
                case 'type-selector-tabs-section-layout-image':
                    return require('../../images/tabs-section-layouts/section-layout-image.svg');
                case 'type-selector-tabs-section-layout-text-and-media':
                    return require('../../images/tabs-section-layouts/section-layout-text-and-media.svg');
                case 'type-selector-tabs-section-layout-text':
                    return require('../../images/tabs-section-layouts/section-layout-text.svg');

                // case study grid layouts
                case 'type-selector-large_list':
                    return require("../../images/thumbnail-alignments/layout/large-grid.svg");
                case 'type-selector-medium_list':
                    return require("../../images/thumbnail-alignments/layout/large-list.svg");
                case 'type-selector-highlight_grid':
                    return require("../../images/thumbnail-alignments/layout/featured-grid.svg");
                case 'type-selector-grid':
                    return require("../../images/thumbnail-alignments/layout/grid.svg");
                case 'type-selector-offset_grid':
                    return require("../../images/thumbnail-alignments/layout/offset.svg");
                case 'type-selector-small_list':
                    return require("../../images/thumbnail-alignments/layout/list.svg");
                case 'type-selector-text_grid':
                    return require("../../images/thumbnail-alignments/layout/small-block-text-only.svg");
                case 'type-selector-text_list':
                    return require("../../images/thumbnail-alignments/layout/large-block-text-only.svg");

                // case study grid interactions
                case 'type-selector-interaction-card-color-change':
                    return require("../../images/thumbnail-alignments/interactions/card-color-change.svg");
                case 'type-selector-interaction-zoom-in':
                    return require("../../images/thumbnail-alignments/interactions/zoom-in.svg");
                case 'type-selector-interaction-show-arrow':
                    return require("../../images/thumbnail-alignments/interactions/show-arrow.svg");
                case 'type-selector-interaction-tilt-image':
                    return require("../../images/thumbnail-alignments/interactions/tilt-image.svg");
                case 'type-selector-interaction-underline-title':
                    return require("../../images/thumbnail-alignments/interactions/underline-title.svg");
                case 'type-selector-interaction-blur-background':
                    return require("../../images/thumbnail-alignments/interactions/blur-background.svg");
                case 'type-selector-interaction-fill-background':
                    return require("../../images/thumbnail-alignments/interactions/fill-background.svg");

                // navigation layouts
                case 'type-selector-navigation-layout-Simple':
                    return require('../../images/navigation-settings/navigation-layout-simple.svg');
                case 'type-selector-navigation-layout-Sides':
                    return require('../../images/navigation-settings/navigation-layout-sides.svg');
                case 'type-selector-navigation-layout-SidesWithCta':
                    return require('../../images/navigation-settings/navigation-layout-sides-with-cta.svg');
                case 'type-selector-navigation-layout-Centered':
                    return require('../../images/navigation-settings/navigation-layout-centered.svg');
                case 'type-selector-navigation-layout-SplitNavigation':
                    return require('../../images/navigation-settings/navigation-layout-split-navigation.svg');
                case 'type-selector-navigation-layout-SplitLogo':
                    return require('../../images/navigation-settings/navigation-layout-split-logo.svg');

                // navigation positions in sidebar
                case 'navigation-sidebar-position-top':
                    return require('../../images/navigation-settings/navigation-sidebar-position-top.svg');
                case 'navigation-sidebar-position-bottom':
                    return require('../../images/navigation-settings/navigation-sidebar-position-bottom.svg');
                case 'navigation-sidebar-position-outside':
                    return require('../../images/navigation-settings/navigation-sidebar-position-outside.svg');
                
                // hero layouts
                case 'type-selector-hero-layout-Modular':
                    return require('../../images/hero-settings/hero-layout-type-modular.svg');
                case 'type-selector-hero-layout-Overlay':
                    return require('../../images/hero-settings/hero-layout-type-overlay.svg');
                case 'type-selector-hero-layout-Sidebar':
                    return require('../../images/hero-settings/hero-layout-type-sidebar.svg');

                // hero content flow
                case 'type-selector-hero-content-flow-vertical':
                    return require('../../images/hero-settings/hero-content-flow-vertical.svg');
                case 'type-selector-hero-content-flow-horizontal':
                    return require('../../images/hero-settings/hero-content-flow-horizontal.svg');

                // cta action types
                case 'type-selector-open-link':
                    return require('../../images/cta-actions/icon-button-link-open-link.svg');
                case 'type-selector-navigate-to-page':
                    return require('../../images/cta-actions/icon-button-link-navigate-to-page.svg');
                case 'type-selector-open-resume':
                    return require('../../images/cta-actions/icon-button-link-open-resume.svg');
                case 'type-selector-copy-email':
                    return require('../../images/cta-actions/icon-button-link-copy-email.svg');

                // cta button action icons
                case 'cta-open-page':
                    return require('../../images/cta-icons/icon-open-page.svg');
                case 'cta-open-page-light':
                    return require('../../images/cta-icons/icon-open-page-light.svg');
                case 'cta-open-link':
                    return require('../../images/cta-icons/icon-open-link.svg');
                case 'cta-open-link-light':
                    return require('../../images/cta-icons/icon-open-link-light.svg');
                case 'cta-open-new-tab':
                    return require('../../images/cta-icons/icon-open-new-tab.svg');
                case 'cta-copy-email':
                    return require('../../images/cta-icons/icon-copy-email.svg');
                case 'cta-copy-email-light':
                    return require('../../images/cta-icons/icon-copy-email-light.svg');

                // navigation button style
                case 'navigation-item-simple':
                    return require('../../images/navigation-settings/navigation-item-simple.svg');
                case 'navigation-item-underlined':
                    return require('../../images/navigation-settings/navigation-item-underlined.svg');
                case 'navigation-item-boxed':
                    return require('../../images/navigation-settings/navigation-item-boxed.svg');
                case 'navigation-visual-style-simple':
                    return require('../../images/navigation-settings/navigation-visual-style-simple.svg');
                case 'navigation-visual-style-framed':
                    return require('../../images/navigation-settings/navigation-visual-style-framed.svg');
                case 'navigation-layout-corder-radius-square':
                    return require('../../images/navigation-settings/navigation-layout-corder-radius-square.svg');
                case 'navigation-layout-corder-radius-rounded':
                    return require('../../images/navigation-settings/navigation-layout-corder-radius-rounded.svg');
                case 'navigation-layout-corder-radius-pill':
                    return require('../../images/navigation-settings/navigation-layout-corder-radius-pill.svg');
                case 'type-selector-navigation-item-hover-Color':
                    return require('../../images/navigation-settings/navigation-item-hover-color.svg');
                case 'type-selector-navigation-item-hover-Underline':
                    return require('../../images/navigation-settings/navigation-item-hover-underline.svg');
                case 'type-selector-navigation-item-hover-FlipText':
                    return require('../../images/navigation-settings/navigation-item-hover-flip-text.svg');
                case 'type-selector-navigation-scroll-effect-ScrollWithPage':
                    return require('../../images/navigation-settings/navigation-scroll-effect-scroll-with-page.svg');
                case 'type-selector-navigation-scroll-effect-StayOnTop':
                    return require('../../images/navigation-settings/navigation-scroll-effect-stay-on-top.svg');
                case 'type-selector-navigation-scroll-effect-AnimateOutAndBack':
                    return require('../../images/navigation-settings/navigation-scroll-effect-animate-out-and-back.svg');
                
                // sidebar
                case 'attach':
                    return require("../../images/sidebar/attach.svg");
                case 'attach_default':
                    return require("../../images/sidebar/attach_default.svg");
                case 'detach':
                    return require("../../images/sidebar/detach.svg");

                // section icons
                case 'articles':
                    return require('../../images/section-icons/articles.svg');
                case 'awards':
                    return require('../../images/section-icons/awards.svg');
                case 'bio':
                    return require('../../images/section-icons/bio.svg');
                case 'aboutme':
                    return require('../../images/section-icons/about-me.svg');
                case 'background':
                    return require('../../images/section-icons/background.svg');
                case 'card-sorting':
                case 'cardsorting':
                case 'projectgrid':
                    return require('../../images/section-icons/card-sorting.svg');
                case 'cj':
                case 'customerjourney':
                    return require('../../images/section-icons/cj.svg');
                case 'columns':
                    return require('../../images/section-icons/columns.svg');
                case 'contactform':
                case 'contact-form':
                    return require('../../images/section-icons/contact-form.svg');
                case 'cta':
                case 'contact':
                    return require('../../images/section-icons/cta.svg');
                case 'dividerline':
                case 'divider':
                    return require('../../images/section-icons/divider.svg');
                case 'education':
                    return require('../../images/section-icons/education.svg');
                case 'experience':
                    return require('../../images/section-icons/experience.svg');
                case 'gallery':
                case 'galleryandmedia':
                    return require('../../images/section-icons/gallery.svg');
                case 'header':
                case 'subheader':
                    return require('../../images/section-icons/header.svg');
                case 'hobbies':
                    return require('../../images/section-icons/hobbies.svg');
                case 'image':
                    return require('../../images/section-icons/image.svg');
                case 'imagetext':
                case 'image-text':
                case 'textandmedia':
                    return require('../../images/section-icons/image-text.svg');
                case 'research':
                case 'interviews':
                    return require('../../images/section-icons/interviews.svg');
                case 'logowall':
                case 'logo-wall':
                    return require('../../images/section-icons/logo-wall.svg');
                case 'media':
                    return require('../../images/section-icons/media.svg');
                case 'closing':
                    return require('../../images/section-icons/closing.svg');
                case 'navigation':
                    return require('../../images/section-icons/navigation.svg');
                case 'personas':
                case 'socialmedia':
                    return require('../../images/section-icons/personas.svg');
                case 'prototype':
                    return require('../../images/section-icons/prototype.svg');
                case 'short-intro':
                case 'shortintro':
                    return require('../../images/section-icons/short-intro.svg');
                case 'sketches':
                    return require('../../images/section-icons/sketches.svg');
                case 'skills':
                case 'services':
                    return require('../../images/section-icons/skills.svg');
                case 'statement':
                case 'bold-statement':
                    return require('../../images/section-icons/statement.svg');
                case 'statistics':
                case 'stat':
                case 'stats':
                    return require('../../images/section-icons/stats.svg');
                case 'surveys':
                    return require('../../images/section-icons/surveys.svg');
                case 'testimonial':
                case 'testimonials':
                case 'quotesandlogos':
                    return require('../../images/section-icons/testimonial.svg');
                case 'text':
                    return require('../../images/section-icons/text.svg');
                case 'ui-design':
                case 'uidesign':
                case 'uishowcase':
                case 'uiDesign':
                    return require('../../images/section-icons/ui-design.svg');
                case 'designpresets':
                    return require('../../images/section-icons/design.svg');
                case 'uj':
                case 'userjourney':
                    return require('../../images/section-icons/uj.svg');
                case 'user-testing':
                case 'usabilitytesting':
                    return require('../../images/section-icons/user-testing.svg');
                case 'video':
                case 'embed':
                    return require('../../images/section-icons/video.svg');
                case 'wireframes':
                    return require('../../images/section-icons/wireframes.svg');
                case 'adplist':
                    return require('../../images/section-icons/adplist.svg');
                case 'introandprocess':
                case 'overview':
                    return require('../../images/section-icons/overview.svg');
                case 'problemandsolution':
                    return require('../../images/section-icons/problem-and-solution.svg');
                case 'goals':
                    return require('../../images/section-icons/goals.svg');
                case 'projectdetails':
                    return require('../../images/section-icons/project-details.svg');
                case 'learningsandnextsteps':
                    return require('../../images/section-icons/learnings-and-next-steps.svg');
                case 'businessimpact':
                    return require('../../images/section-icons/business-impact.svg');
                case 'designsystem':
                    return require('../../images/section-icons/design-system.svg');
                case 'competitors':
                case 'competitiveresearch':
                    return require('../../images/section-icons/competitors.svg');
                case 'mockup':
                    return require('../../images/section-icons/mockup.svg');


                //Module icons
                case 'module-text':
                    return require('../../images/module-icons/module-text.svg');
                case 'module-image':
                    return require('../../images/module-icons/module-image.svg');
                case 'module-media':
                    return require('../../images/module-icons/module-media.svg');
                case 'module-quote':
                    return require('../../images/module-icons/module-quote.svg');
                case 'module-form':
                    return require('../../images/module-icons/module-form.svg');
                case 'module-mockup':
                    return require('../../images/module-icons/module-mockup.svg');

                // page icons
                case 'page-home':
                    return require('../../images/page-icons/icon-page-home.svg');
                case 'page-about':
                    return require('../../images/page-icons/icon-page-about.svg');
                case 'page-blank':
                    return require('../../images/page-icons/icon-page-blank.svg');
                case 'page-contact':
                    return require('../../images/page-icons/icon-page-contact.svg');
                case 'page-link':
                    return require('../../images/page-icons/icon-page-link.svg');
                case 'page-file':
                    return require('../../images/page-icons/icon-page-file.svg');
                case 'page-mailto':
                    return require('../../images/page-icons/icon-page-mailto.svg');
                case 'page-resume-builder':
                    return require('../../images/page-icons/icon-page-resume-builder.svg');

                //Illustration svg-s
                case 'reviews-lg':
                    return require('../../images/illustrations/reviews-lg.svg');
                case 'jobs-board':
                    return require('../../images/illustrations/jobs-board.svg');
                case 'job-fit-checker':
                    return require('../../images/illustrations/job-fit-checker.svg');
                case 'job-fit-checker-volt':
                    return require('../../images/illustrations/job-fit-checker-volt.svg');
                case 'plus-plan':
                case 'vector':
                    return require('../../images/illustrations/vector.svg');
                case 'mark':
                    return require('../../images/illustrations/mark.svg');
                case 'rocket':
                    return require('../../images/illustrations/rocket.svg');
                case 'check-lotti':
                    return require('../../images/checkmark-lotti.svg');
                case 'status-indicator':
                    return require('../../images/illustrations/status-indicator.svg');
                case 'dot':
                    return require('../../images/illustrations/dot.svg');
                case 'confetti':
                    return require('../../images/illustrations/confetti.svg');
                case 'timeline-start':
                    return require('../../images/illustrations/timeline-start.svg');
                case 'timeline-end':
                    return require('../../images/illustrations/timeline-end.svg');
                case 'volt-circle-logo':
                    return require('../../images/volt-circle-logo.svg');

                // Embedded media logos
                case 'adobe':
                    return require('../../images/icon-embed-media-adobe.svg');
                case 'airtable':
                    return require('../../images/icon-embed-media-airtable.svg');
                case 'axshare':
                    return require('../../images/icon-embed-media-axure.svg');
                case 'figjam':
                    return require('../../images/icon-embed-media-figma.svg');
                case 'figma':
                    return require('../../images/icon-embed-media-figma.svg');
                case 'framer':
                    return require('../../images/icon-embed-media-framer.svg');
                case 'google':
                    return require('../../images/icon-embed-media-google.svg');
                case 'invision':
                    return require('../../images/icon-embed-media-invision.svg');
                case 'marvel':
                    return require('../../images/icon-embed-media-marvel.svg');
                case 'miro':
                    return require('../../images/icon-embed-media-miro.svg');
                case 'protopie':
                    return require('../../images/icon-embed-media-protopie.svg');
                case 'vimeo':
                    return require('../../images/icon-embed-media-vimeo.svg');
                case 'youtube':
                    return require('../../images/icon-embed-media-youtube.svg');

                // Embedded media logos
                case 'searchIcon':
                    return require("../../images/general-icons/search-icon.svg");
                case 'proPickIcon':
                    return require("../../images/general-icons/our-picks-category-icon.svg");
                case 'serifIcon':
                    return require("../../images/general-icons/serif-category-icon.svg");
                case 'sansIcon':
                    return require("../../images/general-icons/sans-category-icon.svg");
                case 'monoIcon':
                    return require("../../images/general-icons/mono-category-icon.svg");

                //Review
                case 'tooltip-arrow':
                    return require('../../images/review/tour-arrow.svg');
                case 'positive-aspect':
                    return require('../../images/review/positive-aspect-category.svg')
                case 'areas-of-improvement':
                    return require('../../images/review/areas-of-improvement-category.svg')
                case 'progress-indicator-empty':
                    return require('../../images/review/progress-indicator-empty.svg')
                case 'progress-indicator-step1':
                    return require('../../images/review/progress-indicator-step1.svg')
                case 'progress-indicator-step2':
                    return require('../../images/review/progress-indicator-step2.svg')
                case 'progress-indicator-finished':
                    return require('../../images/review/progress-indicator-finished.svg')
                case 'comment':
                    return require('../../images/review/comment.svg')
                case 'chat':
                    return require('../../images/review/chat.svg')
                case 'reaction':
                    return require('../../images/review/reaction.svg')
                case 'send':
                    return require('../../images/icon-send.svg')
                case 'dots':
                    return require('../../images/icon-more.svg')
                case 'dots-vertical':
                    return require('../../images/icon-more-vertical.svg')

                //ADP list related icons
                case 'adplist-logo':
                    return require('../../images/adplist/adplist-logo.svg')
                case 'attendance-icon':
                    return require('../../images/adplist/attendance-icon.svg')
                case 'mentoring-time-icon':
                    return require('../../images/adplist/mentoring-time-icon.svg')
                case 'sessions-icon':
                    return require('../../images/adplist/sessions-icon.svg')
                case 'book-session':
                    return require('../../images/adplist/book-session.svg')

                // domain states
                case 'active-checkmark':
                    return require("../../images/ic-checkmark-green.svg");
                case 'connecting':
                    return require("../../images/ic-loader.svg");
                case 'waiting':
                    return require("../../images/icon-time.svg");
                case 'not_connected':
                case 'inactive':
                    return require("../../images/icon-danger.svg");
                case 'old_server':
                    return require("../../images/ic-disabled.svg");

                //Template preview
                case 'mobile_preview':
                    return require('../../images/template/mobile_preview_icon.svg');
                case 'desktop_preview':
                    return require('../../images/template/desktop_preview_icon.svg');
 
                //AI Related
                case 'ai-sparkling-icon':
                    return require('../../images/ai-icons/ai-sparkling.svg')
                case 'ai-sparkle-one':
                    return require('../../images/ai-icons/ai-sparkle-one.svg')
                case 'ai-custom-prompt-icon':
                    return require('../../images/ai-icons/ai-custom-prompt-icon.svg')
                case 'ai-fix-grammar-icon':
                    return require('../../images/ai-icons/ai-fix-grammar-icon.svg')
                case 'ai-make-shorter-icon':
                    return require('../../images/ai-icons/ai-make-shorter-icon.svg')
                case 'ai-storytelling-icon':
                    return require('../../images/ai-icons/ai-storytelling-icon.svg')
                case 'ai-stop-icon':
                    return require('../../images/ai-icons/ai-stop-icon.svg')

                // mobile navigation
                case 'mobile-navigation-hamburger':
                    return require('../../images/icon-nav-hamburger.svg');
                case 'mobile-navigation-close':
                    return require('../../images/icon-nav-close.svg');

                case 'bolt':
                    return require('../../images/general-icons/bolt.svg')
                default:
                    console.error(`Image route not defined for section type: ${iconName}`);
                    return require('../../images/general-icons/mono-category-icon.svg');
            }
        }
    }
}

</script>
